module.exports = "pegasus/assets/themelp1/product/106.png";